import React, { lazy, Suspense, useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { HeroHome, HowItWorks, Categories } from "@/components/home/HomeTop";
import { useTeeData } from "@/components/home/useTeeData";
// SQUIDDI-seo - 2026-10-17 · sotto la piega arriva quando serve (vedi HomeBelowFold)
const HomeBelowFold = lazy(() => import("@/components/home/HomeBelowFold"));

/* ─────────────────────────── SCROLL PROGRESS BAR ───────────────────────────
   Barra di avanzamento in cima: solo scroll + CSS, così la home non deve
   caricare la libreria di animazioni nel pacchetto iniziale. */
function ScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setP(h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return (
    <div aria-hidden="true" data-testid="home-scroll-progress"
      className="fixed top-0 left-0 right-0 h-[3px] bg-[#8C52FF] z-[60] origin-left transition-transform duration-150 ease-out motion-reduce:transition-none"
      style={{ transform: `scaleX(${p})` }} />
  );
}

/* ─────────────────────── PAGE ───────────────────────
   Hero statico con selettore B2C/B2B → come funziona → categorie →
   lavorazioni (classifica + barra sconti quantità) → pratica Squiddi Designer in stile
   faldone → storie Squiddi Designer → personalizzatore completo incorporato nella
   pagina → FAQ → CTA finale.
   Il capo di prova (t-shirt girocollo) e la config del configuratore vengono
   caricati una volta sola qui e passati alle sezioni che li usano. */
export default function Home() {
  const tee = useTeeData();
  return (
    <div className="bg-white text-[#0A0616]">
      <Seo path="/" />
      <ScrollProgress />
      <HeroHome />
      <HowItWorks />
      <Categories />
      <Suspense fallback={<div className="min-h-[60vh]" aria-hidden="true" data-testid="home-below-loading" />}>
        <HomeBelowFold tee={tee} />
      </Suspense>
    </div>
  );
}
